export default __webpack_public_path__ + "static/media/ch.8804e0a9.svg";